import { render } from "./PositionsSlider.vue?vue&type=template&id=5c003d1b&scoped=true"
import script from "./PositionsSlider.vue?vue&type=script&lang=js"
export * from "./PositionsSlider.vue?vue&type=script&lang=js"

import "./PositionsSlider.vue?vue&type=style&index=0&id=5c003d1b&scoped=true&lang=css"

import exportComponent from "/opt/tracking-bg-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c003d1b"]])

export default __exports__